export default "__VITE_ASSET__CygF6A1j__"